import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LeaseTypeService from "../../../services/LeaseTypeService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListLeasetype from "../Components/ListLeasetype";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewLeaseTypes() {
  const [leases, setLeases] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  // const messageTimer = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();

  const fetchLeases = async () => {
    setLoading(true);
    try {
      const res = await LeaseTypeService.getAll(currentPage, itemsPerPage);
      setLeases(res.data || []);
      setPageCount(res.totalPages || 0);
    } catch (err) {
      console.error(err);
      showMessage("Error fetching lease types.", "error");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchLeases();
  }, [currentPage]);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleAdd = () => navigate("/cpnl/leasetype/add");

  const handleModify = () => {
    if (!selected) {
      showMessage("Select one lease type to modify.", "error");
      return;
    }
    navigate(`/cpnl/leasetype/add/${selected}`);
  };

  const handleToggleStatus = async (lease) => {
    const newStatus = lease.status === "Active" ? "Inactive" : "Active";
    if (
      !window.confirm(
        `Are you sure do you want to change status as ${newStatus}?`
      )
    )
      return;

    setLoading(true);
    try {
      await LeaseTypeService.toggleStatus(lease.id);
      showMessage(`Lease type status changed as ${newStatus}.`, "success");
      fetchLeases();
    } catch (error) {
      console.error(error);
      showMessage("Error updating lease status.", "error");
    } finally {
      setLoading(false);
    }
  };

  //  FRONTEND SEARCH FILTER
  const filteredLeases = leases.filter((l) =>
    l.leaseType.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Lease Types" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage} />
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {/*  SEARCH + ADD / MODIFY */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Lease Type"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListLeasetype
            loading={loading}
            filteredLeases={filteredLeases}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
